<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g>
      <g></g>
      <g>
        <path
          d="M2.0660171508789062,5.3333251953125L2.0660171508789062,12.7495251953125Q2.0660171508789062,13.6330251953125,2.258288150878906,13.9400251953125Q2.507868150878906,14.3385251953125,2.9567221508789063,14.4784251953125Q3.302517150878906,14.5862251953125,4.156917150878906,14.3613251953125L7.880567150878906,13.3812251953125Q7.987377150878906,13.3531251953125,7.992517150878906,13.3526251953125Q7.999347150878906,13.3519251953125,8.006187150878906,13.3526251953125Q8.011327150878905,13.3531251953125,8.118137150878907,13.3812251953125L11.841787150878906,14.3613251953125Q12.696217150878907,14.5862251953125,13.042017150878907,14.4784251953125Q13.490817150878906,14.3385251953125,13.740417150878907,13.9400251953125Q13.932717150878906,13.6331251953125,13.932717150878906,12.7495251953125L13.932717150878906,5.3333251953125Q13.932717150878906,3.4986151953125,13.642117150878907,2.9380951953125Q13.261717150878907,2.2042551953125002,12.527917150878906,1.8238721953125Q11.967397150878906,1.5333251953125,10.132687150878906,1.5333251953125L5.866017150878906,1.5333251953125Q4.031307150878906,1.5333251953125,3.4707871508789063,1.8238721953125Q2.7369471508789065,2.2042551953125002,2.3565641508789064,2.9380951953125Q2.0660171508789062,3.4986151953125,2.0660171508789062,5.3333251953125ZM3.2752571508789066,13.3030251953125Q3.2660171508789064,13.2883251953125,3.2660171508789064,12.7495251953125L3.2660171508789064,5.3333251953125Q3.2660171508789064,3.7911451953125,3.421947150878906,3.4903251953125Q3.627147150878906,3.0944551953125,4.023017150878906,2.8892551953125Q4.323837150878907,2.7333251953125,5.866017150878906,2.7333251953125L10.132687150878906,2.7333251953125Q11.674867150878907,2.7333251953125,11.975677150878907,2.8892551953125Q12.371517150878907,3.0944551953125,12.576717150878906,3.4903251953125Q12.732717150878907,3.7911451953125,12.732717150878907,5.3333251953125L12.732717150878907,12.7495251953125Q12.732717150878907,13.2883251953125,12.723417150878907,13.3030251953125Q12.709617150878906,13.3250251953125,12.684817150878906,13.3328251953125Q12.668217150878906,13.3380251953125,12.147217150878907,13.2008251953125L8.423587150878905,12.2207251953125Q8.226857150878907,12.1690251953125,8.129227150878906,12.1589251953125Q7.999347150878906,12.1455251953125,7.8694771508789065,12.1589251953125Q7.771847150878906,12.1690251953125,7.575117150878906,12.2207251953125L3.8514671508789062,13.2008251953125Q3.330507150878906,13.3380251953125,3.3138771508789064,13.3328251953125Q3.2890571508789064,13.3250251953125,3.2752571508789066,13.3030251953125ZM7.400647150878906,9.4666551953125L7.400647150878906,8.4000751953125L6.333327150878906,8.4000751953125C6.001957150878907,8.4000751953125,5.733327150878907,8.1314451953125,5.733327150878907,7.8000751953125C5.733327150878907,7.4687051953125,6.001957150878907,7.2000751953125,6.333327150878906,7.2000751953125L7.400647150878906,7.2000751953125L7.400647150878906,6.1333251953125C7.400647150878906,5.8019551953125,7.669277150878906,5.5333251953125,8.000647150878907,5.5333251953125C8.332017150878906,5.5333251953125,8.600647150878906,5.8019551953125,8.600647150878906,6.1333251953125L8.600647150878906,7.2000751953125L9.666667150878906,7.2000751953125C9.998037150878906,7.2000751953125,10.266667150878906,7.4687051953125,10.266667150878906,7.8000751953125C10.266667150878906,8.1314451953125,9.998037150878906,8.4000751953125,9.666667150878906,8.4000751953125L8.600647150878906,8.4000751953125L8.600647150878906,9.4666551953125C8.600647150878906,9.7980251953125,8.332017150878906,10.0666551953125,8.000647150878907,10.0666551953125C7.669277150878906,10.0666551953125,7.400647150878906,9.7980251953125,7.400647150878906,9.4666551953125Z"
          fill-rule="evenodd"
          fill="#6E23E2"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "FollowSvg",
  props: {
    componentConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      const color = this.componentConfig.backgroundColor;
      this.$el.querySelector("path").setAttribute("fill", color);
    },
    // 分享功能
    handleShare() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_share_click",
        shareType: "BCOP运营活动H5",
        shareId: this.$route.params.pageId,
      });
      function getBase64(src) {
        return new Promise((resolve, reject) => {
          const img2 = new Image();
          img2.crossOrigin = "Anonymous"; // 设置跨域属性
          img2.src = src;
          img2.onload = function () {
            const canvas2 = document.createElement("canvas");
            const ctx2 = canvas2.getContext("2d");
            canvas2.width = img2.width;
            canvas2.height = img2.height;
            ctx2.drawImage(img2, 0, 0);
            const base64 = canvas2.toDataURL("image/png");
            resolve(base64);
          };
          img2.onerror = function (e) {
            console.log(e);
            reject(e);
          };
        });
      }
      const { shareTitle, shareIcon, shareDescription } = this.componentConfig;
      const pageId = this.$route.params.pageId;
      const currentHref = window.location.href;
      const currentQuery = window.location.search.split("?")[1];

      // AI 助手分享用
      if (this.$route.name == "Ai" || this.$route.name == "AiSub") {
        let data = {
          share_url: `${location.origin}/Ai${location.search}`,
          sharetxt: shareDescription,
          share_img: shareIcon,
          sharetitle: shareTitle,
        };
        this.$jsBridge.appShare(data).then((result) => {
          console.log("appShare result", result);
        });
        return false;
      }

      const path =
        currentHref.indexOf("?") > -1
          ? `${currentHref}&utm_source=bcop&utm_medium=share&utm_campaign=${pageId}`
          : `${currentHref}?utm_source=bcop&utm_medium=share&utm_campaign=${pageId}`;

      const appShare = (base64) => {
        let data = {
          share_url: path,
          sharetxt: shareDescription,
          share_img: shareIcon,
          sharetitle: shareTitle,
        };
        if (base64) {
          data = {
            ...data,
            mini_program_title: shareTitle,
            mini_program_path: `pages/op/index?id=${pageId}&utm_source=bcop&utm_medium=share&utm_campaign=${pageId}&${currentQuery}`,
            mini_program_image: base64,
            sharePlatform: ["WXSession", "WXTimeline"],
            shareType: "BCOP运营活动H5",
          };
        }
        this.$jsBridge.appShare(data).then((result) => {
          console.log("appShare result", result);
        });
      };
      getBase64(shareIcon)
        .then((res) => {
          let base64 = "";
          if (res) {
            base64 = res.replace("data:image/png;base64,", "");
            appShare(base64);
          }
        })
        .catch((e) => {
          console.log(e);
          appShare();
        });
    },
  },
};
</script>
